export function formatPrice(price: number) {
  // 가격이 1,000,000원 미만이면 원 단위 그대로 반환
  if (price < 1_000_000) {
    return price.toLocaleString() + '원';
  }

  // 가격이 1,000,000원 이상인 경우
  // 1만원 단위로 나누고 반올림하여 만원 단위로 변환
  const roundedPriceInTenThousand = Math.round(price / 10000);
  return roundedPriceInTenThousand.toLocaleString() + '만원';
}
